import { Box, IconButton, Typography } from '@mui/material';
import React from 'react';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

const CommonPagination = ({ rowsPerPage, count, page, onPageChange }) => {
    const totalPages = Math.ceil(count / rowsPerPage);
    const currentPage = page + 1; // Adjust for 0-based index

    const handlePreviousPage = () => {
        if (page > 0) {
            onPageChange(null, page - 1);
        }
    };

    const handleNextPage = () => {
        if (page < totalPages - 1) {
            onPageChange(null, page + 1);
        }
    };

    const start = (page * rowsPerPage) + 1;
    const end = Math.min((page + 1) * rowsPerPage, count);

    return (
        <Box sx={{ 
            display: "flex", 
            justifyContent: "space-between", 
            alignItems: "center", 
            height: "25px",
            padding: "0 16px"
        }}>
            <Typography 
                sx={{
                    fontSize: {
                        xs: '12px', sm: '13px', md: '14px', lg: '14px', xl: '14px'
                    }, 
                    fontWeight: 500,
                    color: 'black'
                }}
            >
                {`${start}-${end} of ${count}`} &nbsp; &nbsp; &nbsp;
                {`${currentPage}/${totalPages}`}
            </Typography>
            
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <IconButton
                    onClick={handlePreviousPage}
                    disabled={page === 0}
                    sx={{
                        padding: '4px',
                        color: page === 0 ? 'rgba(0, 0, 0, 0.26)' : 'black',
                        '&.Mui-disabled': {
                            opacity: 0.5,
                        }
                    }}
                >
                    <NavigateBeforeIcon />
                </IconButton>
                <IconButton
                    onClick={handleNextPage}
                    disabled={page >= totalPages - 1}
                    sx={{
                        padding: '4px',
                        color: page >= totalPages - 1 ? 'rgba(0, 0, 0, 0.26)' : 'black',
                        '&.Mui-disabled': {
                            opacity: 0.5,
                        }
                    }}
                >
                    <NavigateNextIcon />
                </IconButton>
            </Box>
        </Box>
    );
};

export default CommonPagination;
